import React from 'react';
import classes from './Button.module.css';
import {BUTTON_TYPES} from "./buttonTypes";

const Button = ({
    onClick,
    children,
    icon,
    type,
    styles,
    disabled
  }) => {
  const classesList = [classes.Button];
  
  switch (type) {
    case BUTTON_TYPES.PRIMARY:
      classesList.push(classes.Primary);
      break;
    case BUTTON_TYPES.REGULAR:
      classesList.push(classes.Regular);
      break;
    default:
      classesList.push(classes.Regular);
  }
  
  return (
      <div>
        <button
            className={classesList.join(' ')}
            onClick={onClick}
            style={styles}
            disabled={disabled}
        >
          {icon && <img src={icon} alt="button-icon" />}
          {children}
        </button>
      </div>
  );
};

export default Button;